export default "__VITE_ASSET__HhYvSU4c__"